<template>
<fragment>
    <div v-if="part==='home'" class="w-full h-screen flex flex-col items-center justify-between">
        <div class="flex flex-col w-full overflow-y-auto">
            <div class="sticky top-0">
                <div class="w-full py-4 px-4 border-b border-gray-200 flex flex-row justify-center">
                    <div>INVENTORY</div>
                </div>
                <div class="w-full h- py-4 px-4 border-b border-gray-200 flex flex-row justify-between">
                    <div>Slot</div>
                    <div class="font-bold text-indigo-600" @click="forSlot()">{{itemName(slotName(slot), 'Select')}}</div>
                </div>
                <div v-if="slot" class="w-full h- pt-4 pb-2 px-4 flex flex-row justify-center border-b border-gray-200">
                    <button @click="forAsset()" class="bg-indigo-600 mb-2 p-2 px-16 text-white rounded-lg">Scan</button>
                </div>
            </div>
            <div v-for="item in assets" :key="item.autralis_id" @click="select(item)"  class="w-full h- p-2 border-b border-gray-200">
                <div class="flex flex-row justify-between">
                    <div class="truncate"><span class="font-bold">{{item.make_text}}</span> {{item.model_text}}</div>
                    <div ><span class="font-bold text-teal-500">{{item.slot_name}}</span></div>
                </div>
                <div><span class="font-bold text-indigo-600">{{item.registration}}</span> - {{item.vin}}</div>
            </div>
        </div>
        <div class="py-2 border-t border-gray-200 bg-white w-full text-center">
            <button @click="endInventory" class="bg-indigo-600 mb-2 p-2 px-8 rounded-lg text-white">Close SLOT</button>
            <button @click="back" class="bg-gray-200 ml-16 mb-2 p-2 px-4 text-indigo-700 rounded-lg focus:bg-indigo-200">Back</button>
        </div>
    </div>
    <Slot v-if="part==='slot'" v-on:back="part='home'" v-on:slot="selectSlot"></Slot>
    <Asset v-if="part==='asset'" v-on:back="part='home'" v-on:asset="selectAsset"></Asset>
    <Box v-if="part==='box'" v-on:back="part='home'" v-on:asset="selectBox"></Box>
</fragment>
</template>

<script>
    import Slot from './Slot.vue'
    import Asset from './Asset.vue'
    import Box from './Box.vue'
    import {slotName} from "../library/common";
    import {remove} from "lodash";

    export default {
        name: "Move",
        components : {
            Slot,
            Asset,
            Box,
        },
        data: function() {
            return {
                qrCode: '',
                slot: null,
                assets: [],
                part: 'home'
            }
        },
        methods: {
            back() {
                this.$emit("back")
            },
            endInventory() {
                this.$emit("back")
            },
            forSlot() {
                this.part = 'slot';
            },
            forAsset() {
                this.part = 'asset';
            },
            selectSlot(slot) {
                this.part = 'home';
                this.slot = slot;
            },
            selectAsset(asset) {
                this.part = 'home';
                this.assets.push(asset)
            },
            slotName(slot) {
                return slotName(slot);
            },
            itemName(item, def) {
                if(item===null) return def;
                return item;
            },
            select(item) {
                remove(this.assets, (asset) => { asset.autralis_id = item.id });
            }
        }
    }
</script>

<style scoped>

</style>